@if (!props.showAsLabel) {
  <cap-input
    appInputPrefix
    [prefix]="props.prefix"
    [prefixDisabled]="!props.prefix"
    dndDropzone
    [type]="props.type || 'text'"
    [class]="props.styleClass"
    [placeholder]="props.translatePlaceholder || props.placeholder | observablePipe | async"
    [formlyAttributes]="field"
    [autocomplete]="props.autocomplete || 'off'"
    [formControl]="formControl"
    [readonly]="props.readonly"
    [class.ng-dirty]="showError"
    [floatLabel]="(props.label_position | observablePipe | async) === 'floating'"
    [label]="(props.label_position | observablePipe | async) === 'floating' ? props.label : ''"
    [dndDisableDropIf]="props.notDroppable"
    [filter]="props.filter || defaultFilter"
    (dndDrop)="onDrop($event)" />
} @else if (props.showAsLabel && props.readonly) {
  <div class="show-as-label">
    <span class="label">{{ formControl.value }}</span>
    @if (props.extraContent) {
      <span class="extra-content">{{ props.extraContent }}</span>
    }
    @if (props.required && !props.hideRequiredMarker) {
      <span>*</span>
    }
  </div>
}
